/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PatchTableRequest model module.
 * @module model/PatchTableRequest
 * @version 2.8.0
 */
class PatchTableRequest {
    /**
     * Constructs a new <code>PatchTableRequest</code>.
     * @alias module:model/PatchTableRequest
     */
    constructor() { 
        
        PatchTableRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PatchTableRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PatchTableRequest} obj Optional instance to populate.
     * @return {module:model/PatchTableRequest} The populated <code>PatchTableRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PatchTableRequest();

            if (data.hasOwnProperty('projectCollection')) {
                obj['projectCollection'] = ApiClient.convertToType(data['projectCollection'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} projectCollection
 */
PatchTableRequest.prototype['projectCollection'] = undefined;






export default PatchTableRequest;

